import { gql } from "@apollo/client"
import { UseQueryOptions } from "@oysterhr/core"
import { VATOptions } from "../types"
import { usePublicCostCalculatorQuery } from "./usePublicCostCalculatorQuery"

export const VAT_OPTIONS_QUERY = gql`
  query VatOptions($countryCode: String!) {
    vatOptions(countryCode: $countryCode) {
      countryName
      requiresWorksInCountryOfResidence
      requiresSalesToCountry
      requiresSalesPercentageToCountry
    }
  }
`

export const useVatOptionsQuery = (
  opts?: UseQueryOptions<
    {
      vatOptions: VATOptions
    },
    {
      countryCode: string
    }
  >,
) => usePublicCostCalculatorQuery(VAT_OPTIONS_QUERY, opts)
